// src/redux/slices/moduleSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getModules } from "@/api/new-api/module";

// Async thunk to fetch modules
export const fetchModules = createAsyncThunk(
  "modules/fetchModules",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getModules();
      if (response.status === "success") {
        return response.data.modules;
      } else {
        return rejectWithValue(response.message || "Failed to fetch modules");
      }
    } catch (error) {
      return rejectWithValue(error?.message || "Something went wrong");
    }
  }
);

const moduleSlice = createSlice({
  name: "modules",
  initialState: {
    modules: [],
    loading: false,
    error: null,
  },
  reducers: {
    resetModules: (state) => {
      state.modules = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchModules.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchModules.fulfilled, (state, action) => {
        state.loading = false;
        state.modules = action.payload;
      })
      .addCase(fetchModules.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetModules } = moduleSlice.actions;

export default moduleSlice.reducer;
